import NewUIDesignModal from './NewUIDesignModal';

export default NewUIDesignModal;
